import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	clearFiltersButton: {
		alignSelf: 'flex-end',
	},
	filter: {
		marginBottom: 20,
		display: 'grid',
		gap: 8,
		gridTemplateColumns: 'repeat(auto-fill, minmax(min(272px, 100%), 1fr))',
	},
	filterGroup: {
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
	},
	label: {
		fontSize: 12,
		fontWeight: 'bold',
	},
});
